import { useState } from "react";
import { api, formatApiErrorDetail } from "../../../lib/api";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { Textarea } from "../../../components/ui/textarea";
import { toast } from "sonner";
import { Section, Field } from "./shared";

const STATUSES = ["pending", "active", "suspended"];
const ROLES = ["user", "admin"];
const SELECT_CLS = "w-full bg-background border border-white/10 rounded-lg px-3 h-9 text-sm";

export function UserProfileForm({ user, onSaved }) {
    const [form, setForm] = useState({
        full_name: user.full_name || "",
        email: user.email || "",
        company_name: user.company_name || "",
        company_website: user.company_website || "",
        monthly_spend: user.monthly_spend || "",
        telegram_handle: user.telegram_handle || "",
        status: user.status,
        role: user.role,
        admin_note: user.admin_note || "",
    });
    const [saving, setSaving] = useState(false);
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await api.patch(`/admin/users/${user.id}`, { ...form, email: form.email.trim().toLowerCase() });
            toast.success("Profil güncellendi");
            onSaved();
        } catch (err) {
            toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Kaydedilemedi");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Section title="Profil bilgileri" subtitle="Kullanıcının tüm kimlik ve iletişim alanlarını buradan düzenleyin." testid="user-profile-section">
            <form onSubmit={submit} className="space-y-4" data-testid="user-profile-form">
                <div className="grid md:grid-cols-2 gap-4">
                    <Field label="Ad Soyad"><Input value={form.full_name} onChange={set("full_name")} data-testid="profile-full-name" className="bg-background border-white/10 h-9" required /></Field>
                    <Field label="E-posta (giriş)"><Input type="email" value={form.email} onChange={set("email")} data-testid="profile-email" className="bg-background border-white/10 h-9 font-mono" required /></Field>
                    <Field label="Şirket adı"><Input value={form.company_name} onChange={set("company_name")} data-testid="profile-company" className="bg-background border-white/10 h-9" /></Field>
                    <Field label="Şirket web sitesi"><Input value={form.company_website} onChange={set("company_website")} data-testid="profile-website" className="bg-background border-white/10 h-9" /></Field>
                    <Field label="Beyan edilen aylık harcama"><Input value={form.monthly_spend} onChange={set("monthly_spend")} data-testid="profile-monthly-spend" placeholder="örn. $50k–$100k" className="bg-background border-white/10 h-9" /></Field>
                    <Field label="Telegram / WhatsApp"><Input value={form.telegram_handle} onChange={set("telegram_handle")} data-testid="profile-telegram" placeholder="@kullanici veya +90…" className="bg-background border-white/10 h-9" /></Field>
                    <Field label="Durum">
                        <select value={form.status} onChange={set("status")} data-testid="profile-status" className={SELECT_CLS}>
                            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                        </select>
                    </Field>
                    <Field label="Rol">
                        <select value={form.role} onChange={set("role")} data-testid="profile-role" className={SELECT_CLS}>
                            {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                        </select>
                    </Field>
                </div>
                <Field label="Admin notu (kullanıcı görmez)">
                    <Textarea rows={3} value={form.admin_note} onChange={set("admin_note")} data-testid="profile-admin-note" placeholder="VIP, özel anlaşma, risk notu…" className="bg-background border-white/10" />
                </Field>
                <div className="flex justify-end">
                    <Button type="submit" disabled={saving} data-testid="profile-save" className="bg-primary text-primary-foreground">{saving ? "Kaydediliyor…" : "Profili kaydet"}</Button>
                </div>
            </form>
        </Section>
    );
}
